// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__u_Z8q","clinicsSelect":"styles_clinicsSelect__2NYPQ"};